import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';

export default function useSavedReports(orgId) {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (!orgId) {
      setReports([]);
      return;
    }
    setIsLoading(true);
    const res = await analyticsService.listSavedReports(orgId);
    setReports(res.ok ? res.data?.results || [] : []);
    setIsLoading(false);
  }, [orgId]);

  useEffect(() => {
    load();
  }, [load]);

  const createReport = useCallback(
    async (payload) => {
      const res = await analyticsService.createSavedReport(payload, orgId);
      if (res.ok) await load();
      return res;
    },
    [orgId, load]
  );

  const updateReport = useCallback(
    async (reportId, payload) => {
      const res = await analyticsService.updateSavedReport(reportId, payload, orgId);
      if (res.ok) await load();
      return res;
    },
    [orgId, load]
  );

  return { reports, isLoading, reload: load, createReport, updateReport };
}
